import { render, staticRenderFns } from "./restrictHighConsumeList.vue?vue&type=template&id=7b38b108&scoped=true"
import script from "./restrictHighConsumeList.vue?vue&type=script&lang=js"
export * from "./restrictHighConsumeList.vue?vue&type=script&lang=js"
import style0 from "./restrictHighConsumeList.vue?vue&type=style&index=0&id=7b38b108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38b108",
  null
  
)

export default component.exports